import Vue from 'vue'
import { getLoginUser, resendEmail, cancelEmail } from '@/api/user'
import imageCompression from 'browser-image-compression'
import SimpleDialog from '@/components/dialog/simple-dialog/index.vue'
import DropdownDatepicker from '@/components/dropdown-datepicker/dropdown-datepicker.vue'
import { corpMixins } from '@/mixins/corp-mixins'

export default Vue.extend({
  mixins: [corpMixins],
  name: 'ProfileDetail',
  components: {
    SimpleDialog,
    DropdownDatepicker
  },
  data() {
    return {
      displayDialog: false,
      text: '',
      color: '',
      profile: {
        polarisId: '',
        nickName: '',
        birthDate: '',
        email: '',
        image: null,
        uncomfirmedEmail: false,
        aggregateName: {},
        companyName: '',
        destroyImage: false
      },
      preview: '',
      password: '',
      error: '',
      valid: false,
      confirmationPassword: '',
      dialog: false,
      required(propertyType: any) {
        return (v: string) =>
          (v && v.length > 0) || `${propertyType}は入力必須項目です`
      },
      minLength(min_value: number) {
        return (v: string) => {
          if (v) return v.length >= min_value || `${min_value}文字以上で入力してください`
          else return true
        }
      },
      maxLength(max_value: number) {
        return (v: string) =>
          (v && v.length <= max_value) || `${max_value}文字未満で入力してください`
      },
      validEmail() {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (v: string) =>
          (v && re.test(v)) || `正しいメールアドレスを入力してください`
      },
      preventJapaneseText() {
        let japanRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g
        return (v: any) => {
          if (v) return !japanRegex.test(v) || '半角英数字、及び記号のみで入力してください。'
          return true
        }
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('loading')
    await this.fetchUser()
    await this.$store.dispatch('loading', false)
    const elm = document.getElementsByClassName('v-window')[0]
    // @ts-ignore
    elm.style.setProperty('background-color', 'transparent', 'important')
  },
  computed: {
    passwordConfirmationRule() {
      return () => {
        if ((this.password && this.confirmationPassword) || !this.password) return (this.password === this.confirmationPassword) || 'パスワードが一致しません'
        else return true
      }
    },
    uniqueEmail() {
      return () => (!this.error && this.error.length === 0) || 'このメールアドレスは既に登録されています'
    },
    requireConfirm() {
      return () => {
        if (this.password && !this.confirmationPassword) return 'パスワード（確認用)は入力必須項目です'
        else return true
      }
    }
  },
  methods: {
    openDialog() {
      this.displayDialog = true
    },
    submit() {
      this.$store.dispatch('clearMessage')
      if (this.password === this.confirmationPassword) {
        Object.assign(this.profile, {
          password: this.password,
          confirmPassword: this.confirmationPassword
        })
      }
      this.$nextTick(async () => {
        let res = await this.$store.dispatch('updateProfile', this.profile)
        if (res.errors) {
          this.error = res.errors
        } else {
          this.fetchUser()
        }
      })
    },
    async fetchUser() {
      await getLoginUser().then(res => {
        this.profile.polarisId = res.data.polaris_id
        this.profile.nickName = res.data.nickname
        this.profile.email = res.data.email
        this.profile.birthDate = res.data.birth_date
        this.profile.companyName = res.data.company_name
        this.profile.aggregateName = res.data.aggregate_item
        if (res.data.image && res.data.image !== '') {
          this.preview = process.env.VUE_APP_API_BASE_URL + res.data.image
        }
        this.profile.uncomfirmedEmail = res.data.unconfirmed_email
      })
    },
    resend() {
      resendEmail().then((res: any) => {
        if (res.errors) {
          this.error = res.errors
        } else {
          this.$notify({
            text: 'メールを再送信しました',
            type: 'success'
          })
        }
      })
    },
    goToWithdrawal() {
      this.$router.push({ path: '/withdrawal' })
    },
    async handleImageUpload(event: any) {
      const imageFile = event.target.files[0]

      const options = {
        maxSizeMB: 1,
        useWebWorker: true
      }

      if (imageFile !== undefined) {
        this.profile.destroyImage = false
        if (imageFile['type'] !== 'image/jpeg' && imageFile['type'] !== 'image/png') {
          this.$notify({
            text: 'PNG/JPGのいずれかの形式でアプロードしてください',
            type: 'error'
          })
          return
        }
        try {
          const compressedFile = await imageCompression(imageFile, options)
          if (compressedFile.size > 1400000) {
            this.$notify({
              text: '1MB以下でアップロードしてください',
              type: 'error'
            })
            return
          } else {
            // @ts-ignore
            this.profile.image = compressedFile
            this.preview = URL.createObjectURL(compressedFile)
          }
        } catch (error) {
          return error
        }
      }
    },
    clearError() {
      this.error = ''
    },
    preventJapaneseInput(e: any) {
      let japanRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g
      if (japanRegex.test(e.key)) {
        e.preventDefault()
      }
    },
    resetImg(this: any) {
      this.$refs.upload.value = ''
      this.preview = ''
      this.profile.destroyImage = true
    }
  }
})
